import { render, staticRenderFns } from "./periodStudent.vue?vue&type=template&id=e72267d6&scoped=true&"
import script from "./periodStudent.vue?vue&type=script&lang=js&"
export * from "./periodStudent.vue?vue&type=script&lang=js&"
import style0 from "./periodStudent.vue?vue&type=style&index=0&id=e72267d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72267d6",
  null
  
)

export default component.exports